// import Vue from 'vue';
// import Vuetify from 'vuetify/lib';
// import 'vuetify/src/stylus/app.styl';

// import 'vuetify/dist/vuetify.min.css';
// Vue.use(Vuetify, {
//   iconfont: 'md',
// });

import '@mdi/font/css/materialdesignicons.css';
// import Vue from 'vue';
// import Vuetify from 'vuetify/lib';
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
// import 'vuetify/src/styles/main.sass'
import 'vuetify/styles';
// import 'vuetify/dist/vuetify.min.css';

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


// Vue.use(Vuetify);
// export default new Vuetify({
//   defaultAssets: {
//     font: true,
//     icons: 'mdi',
//   },
//   icons: {
//     iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
//   },
// });

// const lightTheme = {
//   dark: false,
//   colors: {
//     background: '#FFFFFF',
//     surface: '#FFFFFF',
//     primary: '#43a047',
//     'primary-darken-1': '#43a047',
//     secondary: '#186c1b',
//     'secondary-darken-1': '#186c1b',
//     error: '#FF5252',
//     info: '#2196F3',
//     success: '#4CAF50',
//     warning: '#FFC107',
//   },
// };

// const darkTheme = {
//   dark: true,
//   colors: {
//     background: '#FFFFFF',
//     surface: '#FFFFFF',
//     primary: '#43a047',
//     'primary-darken-1': '#43a047',
//     secondary: '#186c1b',
//     'secondary-darken-1': '#186c1b',
//     error: '#FF5252',
//     info: '#2196F3',
//     // info: '#448aff',
//     success: '#4CAF50',
//     warning: '#FFC107',
//   },
// };

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    // themes: {
    //   lightTheme,
    // },
  },

  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    }
  },
  components,
  directives, 

});
